import { inIframe } from '@/utils';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { useStyles } from './styles';
import { useAssetsData } from '@/zustand/useAssetsData';

export const Wrapper = () => {
  const { imageUrl, asset_list } =
    useAssetsData((store) => store.assetsData) || {};

  const hasAssets = imageUrl && asset_list?.background_image;

  const styles = useStyles({
    backgroundUrl: hasAssets
      ? `${imageUrl}/${asset_list?.background_image}`
      : null
  });

  const isInIframe = inIframe();

  if (isInIframe) return <Outlet />;

  return (
    <div className={styles.wrapper}>
      <Outlet />
    </div>
  );
};
